import { Component, OnInit } from '@angular/core';
import { ColmecWorkingOrderStepComponent } from '../colmec-working-order-step/colmec-working-order-step.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { gungAddRemoveSpinner } from 'gung-standard';
import { ColmecWorkOrderExtra } from '../../colmec-working-order-wrapper/colmec-working-order-wrapper.component';

@Component({
    selector: 'colmec-working-order-extras-step',
    templateUrl: './colmec-working-order-extras-step.component.html',
    styleUrls: ['./colmec-working-order-extras-step.component.scss'],
    standalone: false
})
export class ColmecWorkingOrderExtrasStepComponent extends ColmecWorkingOrderStepComponent implements OnInit {
  public form: FormGroup;
  public noExtrasSelected: boolean = false;

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.onNextBtnClicked.subscribe(_ => this.handleNextButtonClicked());
    this.onPreviousBtnClicked.subscribe(_ => this.handlePreviousButtonClicked());
    this.initForm();
  }

  public getLabel(): string {
    return 'EXTRAS';
  }

  private handleNextButtonClicked(): void {
    /*if (this.workingOrder.extras.length === 0) {
      this.noExtrasSelected = true;
      return;
    }*/

    this.stepDone.emit(this.workingOrder);
  }

  private handlePreviousButtonClicked(): void {
    this.stepPrevious.emit(this.workingOrder);
  }

  protected initForm(): void {
    this.form = new FormGroup({
      id: new FormControl('', [Validators.required]),
      qty: new FormControl(null, [Validators.required]),
      description: new FormControl('', []),
      price: new FormControl(null, [Validators.required]),
      grossPrice: new FormControl(null, [Validators.required])
    });
  }

  protected addToWorkingOrder({ target }): void {
    gungAddRemoveSpinner(target);
    const rawForm = this.form.getRawValue();

    const extra: ColmecWorkOrderExtra = {
      id: rawForm.id,
      name: null,
      extra: {
        qty: rawForm.qty,
        grossPrice: rawForm.grossPrice
      },
      description: rawForm.description,
      price: rawForm.price.toString()
    };

    this.workingOrder.extras.push(extra);
    this.noExtrasSelected = false;
    gungAddRemoveSpinner(target);
    this.form.reset({
      id: '',
      qty: '',
      description: '',
      price: '',
      grossPrice: ''
    });
    this.form.markAsPristine();
  }

  protected removeFromWorkingOrder(index: number): void {
    this.workingOrder.extras.splice(index, 1);
  }
}
